<div class="table-responsive text-nowrap">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">{{ ('country' | translate)?.toUpperCase() }}</th>
        <th scope="col">
          {{ ('travel_start_date' | translate)?.toUpperCase() }}
        </th>
        <th scope="col">
          {{ ('travel_end_date' | translate)?.toUpperCase() }}
        </th>
      </tr>
    </thead>

    <tbody class="table-group-divider border-light-subtle">
      <tr *ngFor="let item of travel_details">
        <td>
          {{ item.country.name }}
        </td>
        <td>
          {{ item.arrival_date }}
        </td>
        <td>
          {{ item.departure_date }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
